module.exports = __webpack_public_path__ + "media/application/images/svgs/info-circle-3e25f911d7b4e1667484c3db8d79a360.svg";